import { generateAccountStatusId } from 'dashboard/lib/stubs/account';
import { generateAccountTypeId } from 'dashboard/lib/stubs/account-type';
import { AccountStatus } from 'dashboard/models/account-status';
import { AccountType, AccountTypeAttributes } from 'dashboard/models/account-type';
import { FieldSchemaType } from 'lib/fields';
import { ApiModel } from 'lib/interfaces/api';

export function createPreviewAccountType(
  attributes?: Partial<AccountTypeAttributes>,
  id?: string,
  defaultStatusId?: string,
  statuses?: AccountStatus[],
): AccountType {
  return {
    id: id || generateAccountTypeId(),
    type: ApiModel.AccountType,
    attributes: {
      'created-at': '2019-10-19T06:31:58.000Z',
      'updated-at': '2019-10-19T09:31:58.000Z',
      'is-legacy-account-type': false,
      name: 'txn type',
      'field-schemas': [
        {
          key: 'first_name',
          label: 'First name',
          type: FieldSchemaType.String,
          config: {},
        },
        {
          key: 'last_name',
          label: 'Last name',
          type: FieldSchemaType.Integer,
          config: {},
        },
        {
          key: 'product_lines',
          label: 'Product Lines',
          type: FieldSchemaType.MultiChoices,
          config: {
            options: ['business_banking', 'instant_deposit', 'payroll'],
            'option-labels': ['Businss banking', 'Instant deposit', 'Payroll'],
          },
        },
        {
          key: 'geo',
          label: 'Geo',
          type: FieldSchemaType.Choices,
          config: {
            options: ['us', 'ca', 'mx'],
            'option-labels': ['United States', 'Canada', 'Mexico'],
          },
        },
      ],
      'relation-schemas': [],
      identifiers: [],
      ...attributes,
    },
    relationships: {
      'default-account-status': {
        data: {
          type: ApiModel.AccountStatus,
          id: defaultStatusId || generateAccountStatusId(),
        },
      },
      'account-statuses': {
        data: (statuses || []).map((status) => {
          return { type: ApiModel.AccountStatus, id: status.id };
        }),
      },
      'default-graph-query-template': { data: { type: ApiModel.GraphQueryTemplate, id: '1' } },
    },
  };
}
